export * from './search-bar.component';
export * from './search-url-param.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/search/search-bar/index.ts